export function mv() {
  $(window).on('load', function(){
    setTimeout(function(){
      $('.js-animation').addClass('is-animated');
    },500);
  });
}